import { AUTH_REALM } from "@/constants";
import { notifyApiMutation } from "@/shared/api/apiMutationEvents";
import { performApiRequest, buildApiUrl } from "@/shared/api/performApiRequest";
import {
  assertTenantAuthRealm,
  resolveAuthRealm,
} from "@/shared/auth/authRealm";
import { getTenantFromHostname } from "@/shared/tenant/getTenantFromHostname";

export { buildApiUrl };

/**
 * Tenant-scoped Olive API client. Requires a tenant subdomain hostname and sends
 * the `tenant` header. Uses tenant-realm Cognito tokens only.
 */
export async function apiFetch(
  path: string,
  init: RequestInit = {},
): Promise<Response> {
  const realm = resolveAuthRealm();
  assertTenantAuthRealm(realm);

  const tenant = getTenantFromHostname(window.location.hostname);
  if (!tenant) {
    throw new Error(
      "Could not resolve tenant from the hostname. Use a tenant subdomain (e.g. acme.local.olivelabs.ai).",
    );
  }

  const response = await performApiRequest(path, init, {
    authRealm: AUTH_REALM.TENANT,
    tenantHeader: tenant,
  });
  if (response.ok) {
    notifyApiMutation(path, init.method);
  }
  return response;
}
